import axios from 'axios';
import {
	ENDPOINT_URL,
	GET_MAINTENANCE_INSTANCE_LIST,
	AUTH_TOKEN_ERROR_STATUS_CODE,
	AUTH_TOKEN_ERROR_STATUS_MSG,
	TOKEN_FAILED,
} from '../constants/commonConstants';

import {
	MAINTENANCE_INSTANCE_REQUEST_GET,
	MAINTENANCE_INSTANCE_RESPONSE_GET_SUCCESS,
	MAINTENANCE_INSTANCE_RESPONSE_GET_FAIL,
} from '../constants/maintenanceInstanceConstants';

import { logout } from './userActions';
import { decryptData } from '../utils/crypto';
/* Action creator for listing captive portals.
 *
 * This function asynchronously dispatches actions to fetch a list of roles.
 * It sends a request to the server with optional parameters such as limit and offset.
 * Upon successful response, it dispatches an action with the retrieved data.
 *
 * @param {number} [limit=50] - Optional parameter specifying the maximum number of role entries to fetch.
 * @param {number} [offset=0] - Optional parameter specifying the page no. to fetch the entries from that particular page.
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const listMaintenanceInstances =
	(limit = 50, offset = 0) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: MAINTENANCE_INSTANCE_REQUEST_GET,
			});
			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url:
					ENDPOINT_URL +
					GET_MAINTENANCE_INSTANCE_LIST +
					'?limit=' +
					limit +
					'&offset=' +
					offset};

			//    const { data } = await axios.request(config);
			const encryptDataResp = await axios.request(config);
			const jsonString = decryptData(encryptDataResp.data);
			const data = JSON.parse(jsonString);
			const finalResponse = data;
			console.log(finalResponse, 'finalresponse');
			if (finalResponse && finalResponse.data) {
				dispatch({
					type: MAINTENANCE_INSTANCE_RESPONSE_GET_SUCCESS,
					payload: finalResponse,
				});
			}
			if (
				finalResponse &&
				finalResponse.status &&
				finalResponse.status === AUTH_TOKEN_ERROR_STATUS_CODE &&
				finalResponse.error &&
				finalResponse.error === AUTH_TOKEN_ERROR_STATUS_MSG
			) {
				dispatch({
					type: MAINTENANCE_INSTANCE_RESPONSE_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error?.response && error?.response?.finalResponse?.message
					? error.response.finalResponse.message
					: error?.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: MAINTENANCE_INSTANCE_RESPONSE_GET_FAIL,
				payload: 'Error fetching announcement banner data',
			});
		}
	};
